export const Content = {
    TAG:"©",
    HEADING: ". All rights reserved.",
}